export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('ALREADY_PAYED') === 0 && !messages.find((message) => { return message.message === 'listeEcheancePaiement.popUpCreationRemiseBancaire.errors.alreadyPayed'; })) {
      messages.push({
        message: 'listeEcheancePaiement.popUpCreationRemiseBancaire.errors.alreadyPayed',
      });
    }
  });
}
